import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import { useTheme } from '../../context/ThemeContext';
import './Layout.less';

const Layout: React.FC = () => {
  const { theme } = useTheme();
  
  // 将背景颜色应用到body元素
  useEffect(() => {
    if (theme === 'dark') {
      document.body.style.backgroundColor = '#000000';
      document.body.style.color = '#ffffff';
    } else {
      document.body.style.backgroundColor = '#ffffff';
      document.body.style.color = '#000000';
    }
  }, [theme]);
  
  return (
    <div className={`app-layout theme-${theme}`}>
      <Nav />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;